import axios from "axios";
import { TargetedUnderwriterResponse } from "../orderEntry/types/TargetedUnderwriter";

const logEvent = (eventFunction: string, description: string, additionalInfo: string | undefined = undefined) => {
  (async () => {
    try {
      await axios.post("/api/AnalyticsLogging/logevent", {
        function: eventFunction,
        url: window.location.href,
        description,
        additionalInfo
      });
    } catch {}
  })();
};

const logPageView = () => {
  (async () => {
    try {
      await axios.post("/api/AnalyticsLogging/logpageview", { url: window.location.href });
    } catch {}
  })();
};

const logTargetedUnderwriter = (targetedUnderwriter: TargetedUnderwriterResponse) => {
  (async () => {
    try {
      await axios.post("/api/AnalyticsLogging/logTargetedUnderwriter", targetedUnderwriter);
    } catch {}
  })();
};

type OrderSearchFeedback = {
  isHelpful: boolean;
  notes?: string;
  searchText: string;
  selectedOrderNumber: string | null;
  resultCount: number;
  resultsJson: string;
  sortBy: string;
};

const logOrderSearchFeedback = async (feedback: OrderSearchFeedback) => {
  await axios.post("/api/AnalyticsLogging/ordersearchfeedback", {
    ...feedback,
    url: window.location.href,
  });
};

export { logEvent, logPageView, logTargetedUnderwriter, logOrderSearchFeedback };
